import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs, watchEffect } from "vue";
  import router from "@/router";
  import SidebarShortPanel from "@/v2/components/SidebarShortPanel.vue";
  import { NavigationItem as OriginalNavigationItem } from "@/types";
  import store from "@/store";
  import { hasRequiredTier } from "@/helpers/getUserTier";

  type NavigationItem = OriginalNavigationItem & { canAccess?: boolean };

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarComponent',
  props: {
    navigation: {},
    isActiveBurger: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const activeRoute = ref("");

  const navTitle = computed(() => {
    const { fullPath } = router.currentRoute.value;

    if (fullPath.startsWith("/v2/profile")) {
      return "Settings";
    }

    return "";
  });

  const selectedEstate = computed(() => {
    return store.state.user.landownerEstates.find(
      (estate) => estate._id === store.state.user.selectedEstateId
    );
  });

  const { navigation } = toRefs(props);
  const userData = computed(() => store.state.user.data);
  const navigationWithAccess = ref<NavigationItem[]>([]);

  watchEffect(() => {
    Promise.all(
      navigation.value.map(async (item) => ({
        ...item,
        canAccess: item.requiredTier
          ? await hasRequiredTier(userData.value, item.requiredTier)
          : true,
      }))
    ).then((nav) => {
      navigationWithAccess.value = nav;
    });
  });

  function getActiveRouteClass(item: NavigationItem) {
    const { fullPath } = router.currentRoute.value;
    const path = getSlugPath();

    if (fullPath.startsWith("/v2/profile")) {
      return item.slug === path.split("/")[1] ? "active" : "";
    }

    return item.slug === path.split("/")[2] ? "active" : "";
  }

  function getSlugPath() {
    const { meta, fullPath } = router.currentRoute.value;

    return fullPath.replace("/v2/profile", "");
  }

  function onNavigationLink(item: NavigationItem) {
    activeRoute.value = item.slug;
  }

const __returned__ = { props, activeRoute, navTitle, selectedEstate, navigation, userData, navigationWithAccess, getActiveRouteClass, getSlugPath, onNavigationLink, computed, ref, toRefs, watchEffect, get router() { return router }, SidebarShortPanel, get OriginalNavigationItem() { return OriginalNavigationItem }, get store() { return store }, get hasRequiredTier() { return hasRequiredTier } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})